import axios from "axios";

/* Deliberately separate from src/hook/useAdsApi.js (which the real /ads flow uses) - same
   auth/base-URL pattern, but kept independent so this flow never depends on that file. */
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

const authHeaders = () => ({
  token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
  "Content-Type": "application/json",
});

export const getMyCampaigns = async (params = {}) => {
  const res = await axios.get(`${API_BASE_URL}/advertisement/my-campaigns`, {
    headers: authHeaders(),
    params,
  });
  return res.data.result;
};

export const promoteListing = async (payload) => {
  const res = await axios.post(`${API_BASE_URL}/advertisement/promote-listing`, payload, {
    headers: authHeaders(),
  });
  return res.data.result;
};

export const createAdSetTargeting = async (adSetId, payload) => {
  const res = await axios.post(`${API_BASE_URL}/advertisement/ad-sets/${adSetId}/targeting`, payload, {
    headers: authHeaders(),
  });
  return res.data.result;
};

// Public endpoint (no auth required) - each row is a whole interest category (id, category,
// tags), not an individual tag. AdSetTargeting.interest_ids references these row ids.
export const getInterestList = async () => {
  const res = await axios.post(`${API_BASE_URL}/interest/list`, {});
  return res.data.result.interests;
};
